import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { ApiResponse } from '@classes/api-response';
import { Settings } from '@models/settings';

export interface PricingSettings {
  dutyAmount: number;
  nosepadsInstallAmount: number;
  drillMountAmount: number;
}

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private baseUrl = `${environment.base_url}/settings`;
  dutyAmount = 50;
  nosepadsInstallAmount = 0;
  drillMountAmount = 0;

  constructor(private http: HttpClient) {}

  loadSettings(): Observable<Settings> {
    return this.http.get<ApiResponse<Settings>>(this.baseUrl).pipe(
      map((res) => new Settings(res.settings)),
      tap((settings) => this.applySettings(settings))
    );
  }

  updateDutyAmount(dutyAmount: number): Observable<Settings> {
    return this.updatePricingSettings({
      dutyAmount,
      nosepadsInstallAmount: this.nosepadsInstallAmount,
      drillMountAmount: this.drillMountAmount,
    });
  }

  updatePricingSettings(pricing: PricingSettings): Observable<Settings> {
    const body = JSON.stringify(pricing);
    return this.http.put<ApiResponse<Settings>>(`${this.baseUrl}/pricing`, body).pipe(
      map((res) => new Settings(res.settings)),
      tap((settings) => this.applySettings(settings))
    );
  }

  getRetailPlusDuty(retail: number | string): number {
    let value = typeof retail === 'string' ? parseFloat(retail.replace(/,/g, '')) : retail;
    value = isNaN(value) ? 0 : value;
    return value + this.dutyAmount;
  }

  getCustomAddOnTotal(options: {
    duty?: boolean;
    nosepadInstall?: boolean;
    drill?: boolean;
  }): number {
    let total = 0;
    if (options.duty) {
      total += this.dutyAmount;
    }
    if (options.nosepadInstall) {
      total += this.nosepadsInstallAmount;
    }
    if (options.drill) {
      total += this.drillMountAmount;
    }
    return total;
  }

  private applySettings(settings: Settings): void {
    this.dutyAmount = settings.dutyAmount;
    this.nosepadsInstallAmount = settings.nosepadsInstallAmount;
    this.drillMountAmount = settings.drillMountAmount;
  }
}
